var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeFairAwardsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.824,
    height: 15.67,
    viewBox: "0 0 11.824 15.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30514",
    "data-name": "Group 30514",
    transform: "translate(0.749 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11804",
    "data-name": "Path 11804",
    d: "M14.571,36.675l.779,1.877h-3.1l-.475-1.145a4.243,4.243,0,1,0,2.8-.732Z",
    transform: "translate(-8.896 -30.473)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11805",
    "data-name": "Path 11805",
    d: "M10.7,10.915H7.6L4.245,2.835h3.1Z",
    transform: "translate(-4.245 -2.835)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11806",
    "data-name": "Path 11806",
    d: "M34.481,2.835,32.417,7.806l.511,1.231a4.218,4.218,0,0,1,1.826.606L37.58,2.835Z",
    transform: "translate(-27.254 -2.835)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeFairAwardsIcon);
export default __webpack_public_path__ + "static/media/trade_fair_awardsIcon.b5211248827e6f4eb2f90477b442c9fb.svg";
export { ForwardRef as ReactComponent };